import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, Dialog, DialogActions, Divider } from '@material-ui/core';
import { flagIcon } from '../../constants/Helpers';
import ProcessingLoader from '../shared/ProcessingLoader';
//API
import AppService from '../../services/AppService';

const CancelInvModal = ({
  selectedInv,
  isPopupOpen,
  setIsPopUpOpen,
  occasionId,
  setSelectedInv,
  fetchUserData,
  setDisableBtn,
}) => {
  const [isLoading, setIsLoading] = useState('');

  const handleApologizeInvitee = async () => {
    const dataBody = {
      accept: false,
    };
    setDisableBtn(true);
    setIsLoading(true);
    try {
      await AppService.getConfirmAttend(dataBody, selectedInv?.id);
      setTimeout(() => {
        fetchUserData(occasionId);
      }, 200);
      setDisableBtn(false);
      setIsLoading(false);
      toast.success(`تم الغاء دعوة ${selectedInv?.name}`);
      setIsPopUpOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.message ?? 'حدث خطأ');
      setDisableBtn(false);
      setIsLoading(false);
      setIsPopUpOpen(false);
    }
  };

  useEffect(() => {
    return () => {
      setSelectedInv('');
    };
  }, []);

  return (
    <div className="">
      <Dialog
        open={isPopupOpen}
        onClose={() => setIsPopUpOpen((prev) => !prev)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ProcessingLoader /> <span>جاري الالغاء ...</span>
          </div>
        ) : (
          <>
            <div
              style={{
                padding: 30,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src={flagIcon.falseIcon} style={{ width: 30, marginRight: 5 }} />
              تأكيد الغاء الدعوة؟
            </div>
            <Divider />
          </>
        )}
        <DialogActions
          style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}
        >
          <Button
            variant="contained"
            type="submit"
            onClick={() => setIsPopUpOpen(false)}
            color="default"
          >
            خروج
          </Button>
          <Button
            style={{ backgroundColor: '#006782', color: 'white', margin: 5 }}
            variant="contained"
            type="submit"
            onClick={handleApologizeInvitee}
            disabled={isLoading}
          >
            تأكيد
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CancelInvModal;
